export default {
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  FORGOT_PASSWORD: '/forgotPassword',
  CREATE_PASSWORD: '/createPassword',
  RESET_PASSWORD_SUCCESS: '/resetPasswordSuccess',
  RESET_PASSWORD_ERROR: '/invalidTokenError',
  ADMIN_ARTIST: '/admin/artist',
  ADMIN_MANAGER: '/admin/manager',
  ADMIN_OFFER: '/admin/offer',
  ADMIN_ANALYTICS: '/admin/analytics',
  ADMIN_CAMPAIGN: '/admin/campaign',
  QUESTIONNAIRE: '/questionnaire',
  CRETAE_OFFER: '/admin/offer/create',
  IMPORT_ARTIST: '/admin/artist/import',
  IMPORT_MANAGER: '/admin/manager/import',
  OFFER_DETAIL: '/admin/offer/detail',
  EDIT_OFFER: '/admin/offer/edit',
  REGISTER_SUCCESS: '/registerSuccess',
};
